<template>
  <div
    :class="
      $route.query.id === ticket.id
        ? 'ticket-card__active'
        : 'ticket-card__inactive'
    "
    @click="[$emit('click'), handleCheckOwner(ticket.operatorAssigned)]"
  >
    <!--    <p>{{ $route.query.id === ticket.id }}</p>-->
    <div class="pending-profile-customer">
      <b-avatar
        v-if="isChatMeTicket(ticket)"
        size="36"
        variant="secondary"
        :text="getFirstLetter(ticket.title || '')"
        class="align-baseline avatar-border customer-avatar"
      />
      <b-avatar
        v-else
        size="36"
        variant="secondary"
        :text="getFirstLetter(ticket.customer.name || '')"
        class="align-baseline avatar-border customer-avatar"
      />

      <template v-if="ticket.assignee !== null && !isChatMeTicket(ticket)">
        <b-avatar
          size="24"
          variant="primary"
          :text="
            getFirstLetter(
              (ticket.assignee && ticket.assignee.firstName) || 'No'
            )
          "
          class="align-baseline avatar-border operator-avatar"
        />
      </template>
    </div>
    <div
      v-if="isChatMeTicket(ticket)"
      style="
        display: flex;
        justify-content: space-between;
        flex: 1;
        align-items: center;
      "
    >
      <div>
        <div class="body-content-card-ticket">
          <!--  -->
          <div class="body-center">
            <p class="title">
              <!--        {{ $t("ticket.account_enable") }}-->
              {{ ticket.title }}
            </p>
            <p v-if="ticket.isPrivateChat" class="email">
              {{ $t("breadcrumb.chatPartner") }}
              <!-- {{ ticket.customer.email || "" }} -->
            </p>
            <p v-else class="email">
              <!-- {{ ticket.customer.email || "" }} -->
            </p>
          </div>
          <!--  -->
          <div class="body-end" />
        </div>
        <div />
        <div class="status-container">
          <div class="status">
            <div style="font-size: 10px">
              <b-badge v-if="ticket.status === 1" size="10px" pill>
                {{ $t("ticket.open") }}
              </b-badge>
              <b-badge
                v-if="ticket.status === 2"
                size="10px"
                pill
                variant="success"
              >
                {{ $t("ticket.resolved") }}
              </b-badge>
              <b-badge
                v-if="ticket.status === 3"
                pill
                variant="warning"
                size="10px"
              >
                {{ $t("ticket.pending") }}
              </b-badge>
            </div>
          </div>
          <p class="date">
            {{ ticket.createdAt | formatShortDate }}
          </p>
        </div>
      </div>
      <b-avatar
        v-if="ticket.badgeCount > 0 && showBadger"
        size="sm"
        :variant="ticket.operatorAssigned === accountId ? 'danger' : 'primary'"
        style="margin-right: 0.5em"
      >
        {{ ticket.badgeCount }}
      </b-avatar>
    </div>

    <div
      v-else
      style="
        display: flex;
        justify-content: space-between;
        flex: 1;
        align-items: center;
      "
    >
      <div>
        <div class="body-content-card-ticket">
          <!--  -->
          <div class="body-center">
            <p class="title">
              <!--        {{ $t("ticket.account_enable") }}-->
              {{ ticket.title }}
            </p>
            <p class="email">
              <!-- {{ ticket.title }} -->
              {{ ticket.customer.email || "" }}
            </p>
          </div>
          <!--  -->
          <div class="body-end" />
        </div>
        <div />
        <div class="status-container">
          <div class="status">
            <div style="font-size: 10px">
              <b-badge v-if="ticket.status === 1" size="10px" pill>
                {{ $t("ticket.open") }}
              </b-badge>
              <b-badge
                v-if="ticket.status === 2"
                size="10px"
                pill
                variant="success"
              >
                {{ $t("ticket.resolved") }}
              </b-badge>
              <b-badge
                v-if="ticket.status === 3"
                pill
                variant="warning"
                size="10px"
              >
                {{ $t("ticket.pending") }}
              </b-badge>
            </div>
          </div>
          <p class="date">
            {{ ticket.createdAt | formatShortDate }}
          </p>
        </div>
      </div>
      <b-avatar
        v-if="ticket.badgeCount > 0 && showBadger"
        size="sm"
        :variant="ticket.operatorAssigned === accountId ? 'danger' : 'primary'"
        style="margin-right: 0.5em"
      >
        {{ ticket.badgeCount }}
      </b-avatar>
    </div>
  </div>
</template>

<script>
import { BAvatar, BBadge } from "bootstrap-vue";
import { ref } from "@vue/composition-api";
import useTicketStore from "@/store-pinia/useTicketStore";

export default {
  components: { BAvatar, BBadge },
  props: {
    active: {
      type: Boolean,
      defaults: false,
    },
    accountId: {
      type: String,
      defaults: "",
    },
    ticket: {
      title: "",
      operatorAssigned: "",
      customer: {
        name: "",
        email: "",
      },
      createdAt: "",
      type: Object,
      defaults: () => ({
        status: 1,
        assignee: {
          firstName: "",
        },
      }),
    },
  },
  setup(props) {
    const showBadger = ref(true);

    function getFirstLetter(text) {
      return text.charAt(0);
    }

    function isChatMeTicket(ticket) {
      return ticket?.isPrivateChat ? true : false;
    }

    function handleCheckOwner(operatorAssigned) {
      console.log("selected Operator", operatorAssigned);
      if (operatorAssigned === props.accountId) {
        showBadger.value = false;
      }
    }
    // console.log(props.ticket)
    return { isChatMeTicket, getFirstLetter, showBadger, handleCheckOwner };
  },
};
</script>

<style lang="scss" scoped>
.ticket-card {
  display: flex;
  cursor: pointer;
  align-items: center;
  padding: 0.5em 0.75em;
}

.ticket-card__inactive {
  @extend .ticket-card;

  &:hover {
    background: whitesmoke;
  }
}

.ticket-card__active {
  @extend .ticket-card;
  //background: #8d5185;
  background: #9f6096;
  color: white;
}

.pending-profile-customer {
  position: relative;
  margin: 0.5rem 1em 0.5rem 0;

  // margin-bottom: 0rem;
  .avatar-border {
    font-weight: 400;
    border: 2px solid whitesmoke;
    box-shadow: 0 4px 8px 0 rgb(47 47 47 / 12%);
  }

  .operator-avatar {
    position: absolute;
    left: 6px;
    bottom: 6px;
  }

  .customer-avatar {
    margin-left: 1em;
    margin-bottom: 1em;
  }
}

// .pending-card{
//   margin: 0.5;
// }
.body-center {
  //overflow: hidden;
  //text-overflow: ellipsis;
  //white-space: nowrap;
  //max-width: 200px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  width: fit-content;
}

.body-end {
  white-space: nowrap;
  text-align: end;
  padding-right: 1.1rem;
  margin-bottom: 0rem;
}

.date {
  font-size: 12px;
  justify-self: end;
  margin-bottom: 0;
  color: #b9b9c3;
}

.status {
  text-align: end;
  font-size: 12px;
  display: flex;
  gap: 0.25em;
  justify-content: right;
}

.email {
  margin-bottom: 0.25em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 400;
  font-size: 12px;
  color: #b9b9c3;
  //width: 200px;
}

.status-container {
  display: flex;
  gap: 0.5em;
}

.card-right-sidebar {
  justify-content: space-between;
}

.body-card-left {
  display: flex;
  justify-content: space-between;
  /* Can be changed in the live sample */
}

.title {
  line-height: 1;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 0;
  overflow: hidden;
  text-overflow: ellipsis;

  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
  width: fit-content;
  //width: 200px;
}

.body-content-card-ticket {
  display: flex;
  justify-content: space-between;
  flex: 1;
  gap: 0.5em;
  align-items: center;
}
</style>
